const t=({breakpoints:s,spacing:p})=>({styleOverrides:{root:{[s.up("sm")]:{padding:p(2),paddingTop:p(1)}}}});export{t as default};
